<template>
  <div :style="{'display': 'grid', 'margin-top': edit == true ? '0' : '2rem'}">
    <button v-if="edit == false" @click="openModal()" class="btn-outline btn-dark"><i class="fa-light fa-plus"></i>Add payment</button>
    <i v-else @click="openModal()" class="fa-regular fa-pen-to-square"></i>

    <!-- modal -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>{{edit == true ? 'Edit Payment' : 'Add Payment'}}<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
        <span style="font-weight: normal; color: #717182;">{{ edit == true ? 'Modify the details of the selected payment. Payment date must be today or in the past.' : 'Create a new payment to add to the queue. Payment date must be today or in the past.'}}</span>
        
        <div style="display: grid;">
          <span class="filter-item-title">VIBAN*</span>
          <input type="text" class="filter-item-content" placeholder="VIBAN..." v-model="newPayment.VIBAN" @input="event => newPayment.VIBAN = sanitize(event.target.value)"/>
          <small>Must be a VIBAN from the VIBAN pool</small>
          <small style="color: #e7000b; display: flex;" v-if="VIBANerror">{{ VIBANerror }}</small>
        </div>

        <div style="display: grid;">
          <span class="filter-item-title">Amount (EUR)*</span>
          <input type="number" class="filter-item-content" placeholder="0.00" step="0.01" min="0" v-model.number="newPayment.amount"/>
          <small style="color: #e7000b; display: flex;" v-if="amountError">{{ amountError }}</small>
        </div>

        <div style="display: grid;">
          <span class="filter-item-title">Payment Date*</span>
          <datetime-picker class="z-1" format="DD/MM/YYYY"
            :class="{'filter-item-input': true, 'filter-item-input-complete': newPayment.date, 'error-datepicker': dateError}"
            customInputParentClass="filter-item-content"
            :maxLength="19"
            :placeholderValue="$t('common.datetime_picker_empty_date')"
            inputIcon="fa-solid fa-calendar"
            v-model="newPayment.date">
          </datetime-picker>
          <span v-if="dateError" class="text-danger">Please enter a valid date</span>
          <small>Date must be today or in the past</small>
        </div>

        <div style="display: grid;">
          <span class="filter-item-title">Payment Reference</span>
          <input type="text" class="filter-item-content" placeholder="Payment reference (optional)" v-model="newPayment.reference" @input="event => newPayment.reference = sanitize(event.target.value)"/>
          <small>Optional - can help identify the payment purpose</small>
        </div>

        <div style="display: flex; justify-content: end; align-items: center; gap: 1rem; margin-top: 2rem;">
          <button class="btn-outline-light btn" @click="closeModal()">Cancel</button>
          <button v-if="edit == false" class="btn-outline btn-dark" @click="addToQueue()">Add to Queue</button>
          <button v-else class="btn-outline btn-dark" @click="save()">Save Changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <script>
import DateTimePicker from '@/components/common/dateTimePicker.vue';
export default {
  components: {
    'datetime-picker': DateTimePicker
  },
  props: {
    "payment": Object,
    "edit": Boolean
  },
  emits: ['save', 'update:payments'],
  name: 'createPaymentModal',
  data(){
    return {
      isModalOpen: false,
      newPayment : {
        ...this.payment,
        amount: Number(this.payment.amount) || 0,
        date: this.payment?.date || null
      },
      dateBegin: this.payment?.date || new Date().toLocaleDateString(),
      dateError: null,
      VIBANerror: null,
      amountError: null
    }
  },
  watch: {
    payment: {
      immediate: true,
      deep: true,
      handler(newPay) {
        this.dateBegin = newPay?.date || null

        this.newPayment = {
          ...newPay,
          amount: Number(newPay?.amount) || 0,
          date: this.dateBegin
        }
      }
    },

    dateBegin(newDate) {
      this.newPayment.date = newDate
    }
  },
  methods: {
    openModal (){
      this.isModalOpen = true
    },
    closeModal (){
      this.isModalOpen = false
      this.newPayment = {
        ...this.payment
      }
    },
    addToQueue(){
      if(this.newPayment.VIBAN == null || this.newPayment.VIBAN == '') {
        this.VIBANerror = "Please enter a valid VIBAN, this field is required"
        return
      } else {
        this.VIBANerror = null
      }

      if(this.newPayment.date == null || this.newPayment.date == '') {
        this.dateError = true
        return
      } else {
        this.dateError = null
      }

      if(Number(this.newPayment.amount) == null || Number(this.newPayment.amount) <= 0) {
        this.amountError = "This field can't be empty or equal to 0, please enter a valid amount"  
        return
      } else {
        this.amountError = null
      }

      this.$engine.services.payments.getGroups({ search : this.newPayment.VIBAN , maxResults : 200})
      .then(res => {
        if(res.data.references.length == 0){
          this.VIBANerror = "VIBAN doesn't match any valid VIBAN"
        } else{
          this.newPayment.status = 1
          this.$emit('update:payments', this.newPayment)
          this.closeModal()
        }
      })
      .catch(err => console.log(err))
    },
    save (){
      if(this.newPayment.VIBAN == null || this.newPayment.VIBAN == '') {
        this.VIBANerror = "Please enter a valid VIBAN, this field is required"
        return
      } else {
        this.VIBANerror = null
      }

      if(this.newPayment.date == null || this.newPayment.date == '') {
        this.dateError = true
        return
      } else {
        this.dateError = null
      }

      if(Number(this.newPayment.amount) == null || Number(this.newPayment.amount) <= 0) {
        this.amountError = "This field can't be empty or equal to 0, please enter a valid amount"  
        return
      }else {
        this.amountError = null
      }

      const sanitized = this.sanitize(this.newPayment.VIBAN)
      if (!sanitized) return

      this.$engine.services.payments.getGroups({ search : sanitized , maxResults : 200})
      .then(res => {
        if(res.data.references.length > 0){
          this.$emit('save', this.newPayment)
          this.closeModal()
        } else {
          this.VIBANerror = "VIBAN doesn't match any valid VIBAN"
        }
      })
      .catch(err => console.log(err))
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-_.]/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    }
  }
}
</script> -->

<script>
import DateTimePicker from '@/components/common/dateTimePicker.vue';

export default {
  components: {
    'datetime-picker': DateTimePicker
  },
  props: {
    payment: Object,
    edit: Boolean
  },
  emits: ['save', 'update:payments'],
  name: 'createPaymentModal',
  data() {
    const today = this.formatDateTime()

    return {
      isModalOpen: false,
      newPayment: {
        ...this.payment,
        amount: Number(this.payment?.amount) || 0,
        date: this.edit ? this.payment.date : today
      },
      dateBegin: this.edit ? this.payment.date : today,
      dateError: null,
      VIBANerror: null,
      amountError: null
    }
  },
  watch: {
    payment: {
      immediate: true,
      deep: true,
      handler(newPay) {
        const today = new Date().toLocaleDateString()

        this.dateBegin = this.edit
          ? (newPay.date ?? null)
          : (newPay.date ?? today)

        this.newPayment = {
          ...newPay,
          amount: Number(newPay.amount ?? 0),
          date: this.dateBegin
        }
      }
    },
    dateBegin(newDate) {
      this.newPayment.date = newDate
    }
  },
  methods: {
   openModal() {
      if (!this.edit && !this.newPayment.date) {
        this.newPayment.date = this.formatDateTime()
      }
      this.isModalOpen = true
    },
    closeModal() {
      const today = new Date()

      this.isModalOpen = false
      this.newPayment = {
        ...this.payment,
        amount: Number(this.payment?.amount) || 0,
        date: this.edit
          ? (this.payment?.date || null)
          : today
      }

      this.dateBegin = this.newPayment.date
      this.dateError = null
      this.VIBANerror = null
      this.amountError = null
    },
    addToQueue() {
      if (this.newPayment.VIBAN == null || this.newPayment.VIBAN == '') {
        this.VIBANerror = "Please enter a valid VIBAN, this field is required"
        return
      } else {
        this.VIBANerror = null
      }

      if (this.newPayment.date == null || this.newPayment.date == '') {
        this.dateError = true
        return
      } else {
        this.dateError = null
      }

      if (Number(this.newPayment.amount) == null || Number(this.newPayment.amount) <= 0) {
        this.amountError = "This field can't be empty or equal to 0, please enter a valid amount"
        return
      } else {
        this.amountError = null
      }

      this.$engine.services.payments.getGroups({ search: this.newPayment.VIBAN, maxResults: 200 })
        .then(res => {
          if (res.data.references.length == 0) {
            this.VIBANerror = "VIBAN doesn't match any valid VIBAN"
          } else {
            this.newPayment.status = 1
            this.$emit('update:payments', this.newPayment)
            this.closeModal()
          }
        })
        .catch(err => console.log(err))
    },
    save() {
      if (this.newPayment.VIBAN == null || this.newPayment.VIBAN == '') {
        this.VIBANerror = "Please enter a valid VIBAN, this field is required"
        return
      } else {
        this.VIBANerror = null
      }

      if (this.newPayment.date == null || this.newPayment.date == '') {
        this.dateError = true
        return
      } else {
        this.dateError = null
      }

      if (Number(this.newPayment.amount) == null || Number(this.newPayment.amount) <= 0) {
        this.amountError = "This field can't be empty or equal to 0, please enter a valid amount"
        return
      } else {
        this.amountError = null
      }

      const sanitized = this.sanitize(this.newPayment.VIBAN)
      if (!sanitized) return

      this.$engine.services.payments.getGroups({ search: sanitized, maxResults: 200 })
        .then(res => {
          if (res.data.references.length > 0) {
            this.$emit('save', this.newPayment)
            this.closeModal()
          } else {
            this.VIBANerror = "VIBAN doesn't match any valid VIBAN"
          }
        })
        .catch(err => console.log(err))
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-_.]/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    },
    formatDateTime(date = new Date()) {
      const pad = (n) => n.toString().padStart(2, '0')
      console.log(`${pad(date.getDate())}/${
        pad(date.getMonth() + 1)
      }/${date.getFullYear()} ${
        pad(date.getHours())
      }:${pad(date.getMinutes())}:${pad(date.getSeconds())}`)
      return `${pad(date.getDate())}/${
        pad(date.getMonth() + 1)
      }/${date.getFullYear()} ${
        pad(date.getHours())
      }:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style scoped>

small{
  display: flex;
  color: #6a7282;
  font-size: 0.85rem;
  margin: 0.25rem 0rem;
}

.modal-container{
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  overflow: hidden;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}
</style>